<template>
    <div class="pop-over">
        <el-popover placement="right" :title="title" width="250" trigger="click" @show="mouseOnQuestion">
            <span class="pop-col-text" slot="reference">{{ data }}</span>
            <p class="pop-over-text">{{ simpleContent }}</p>
        </el-popover>
    </div>
</template>

<script>
export default {
    name: "PopOverText",
    props: ["data", "row"],
    data() {
        return {
            simpleContent: ""
        }
    },
    computed: {
        title() {
            return this.$t("zhiji.answer.answerDetail");
        },
        hoverTextTip() {
            return this.$t("zhiji.answer.hoverTextTip");
        }
    },

    methods: {
        mouseOnQuestion() {
            this.simpleTimeout && clearTimeout(this.simpleTimeout);
            this.simpleTimeout = setTimeout(() => {
                this.row.rowId &&
                    this.zhiji
                        .requestByServiceName("queryQuesSimpleById", {
                            questionId: this.row.rowId
                        })
                        .then(resp => {
                            this.simpleContent = resp.answerText === "null" ? this.hoverTextTip : resp.answerText;
                        });
            }, 200);
        },
    }
};
</script>

<style lang="less" scoped>
.pop-over {
    position: relative;
    .pop-col-text {
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
    }
    &:hover > span {
        cursor: pointer;
    }
}
.pop-over-text {
    margin: 0;
}
/deep/.el-popover--plain {
    padding: 0;
}
</style>
